import { createUseStyles } from '../../theme/theming';

const useFormPageStyles = createUseStyles((theme) => ({
  formPageSection: {
    padding: ({ isMobile } = {}) =>
      isMobile
        ? `${theme.spacing.padding.medium}px ${theme.spacing.padding.regular}px`
        : `${theme.spacing.padding.regular}px ${theme.spacing.padding.medium}px`,
    background: theme?.colors?.background3,
    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    }
  },
  formPageHeader: {
    textAlign: 'center'
  },
  formPageTitle: {
    fontSize: theme.typography.fontSize.h2,
    fontWeight: theme.typography.fontWeight.bold
  },
  formPageSubtitle: {
    marginTop: '8px',
    fontSize: theme.typography.fontSize.h6,
    lineHeight: '23px',
    color: theme?.colors?.gray,
    marginBottom: theme.spacing.margin.tiny
  },
  formPageFormContainer: {
    '& form': {
      padding: '72px',
      background: '#FFFFFF',
      borderRadius: '8px',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.16)'
    }
  },
  inputField: {
    marginTop: '12px'
    // padding: '12px 16px',
    // border: '1px solid #D8E0F0',
    // borderRadius: '16px'
  },
  inputFieldLabel: {
    color: theme?.colors?.lightblack,
    fontSize: theme.typography.fontSize.body,
    fontWeight: theme.typography.fontWeight.semiBold,
    display: 'block',
    marginTop: '20px',
    marginBottom: '12px'
  },
  inputFieldControl: {
    width: '100%',
    borderRadius: '8px',
    border: '1px solid #D8E0F0',
    padding: '12px 16px',
    color: theme?.colors?.lightblack,
    fontSize: theme.typography.fontSize.body
  },
  checkboxField: {
    // padding: '20px',
    // border: '1px solid #D8E0F0',
    // borderRadius: '8px'
  },
  checkBoxFieldLabel: {
    color: theme?.colors?.lightblack,
    fontSize: theme.typography.fontSize.body,
    fontWeight: theme.typography.fontWeight.semiBold,
    marginTop: '20px',
    marginBottom: '12px'
  },
  inputFieldRequired: {
    color: theme?.colors?.lightblack
  },
  checkboxFieldControl: {
    padding: '8px 0',
    '& label': {
      fontSize: theme.typography.fontSize.body,
      marginLeft: '10px',
      color: theme?.colors?.lightblack
    }
  },
  submitBtnContainer: {
    marginTop: theme.spacing.margin.tiny,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    margin: '0 auto',
    '& button': {
      // height: '44px',
      padding: '16px 24px',
      fontSize: theme.typography.fontSize.body,
      cursor: 'pointer',
      borderRadius: '8px'
    }
  },

  // SMALL SCREEN
  '@media screen and (max-width: 767px)': {
    formPageSection: {
      padding: '24px'
    },
    formPageTitle: {
      fontSize: '24px'
    },
    formPageFormContainer: {
      '& form': {
        padding: '16px'
      }
    },
    inputFieldLabel: {
      marginBottom: '8px'
    },
    checkBoxFieldLabel: {
      marginBottom: '8px'
    }
  }
}));

export default useFormPageStyles;
